module.exports = __webpack_public_path__ + "static/media/opensans-bold.8a3993c2.woff";